// src/constants/pagesMeta.js
export const PAGES_META = [
  { path: "/dashboard", label: "Dashboard", views: ["Educator","Student"] },
  { path: "/admin", label: "Admin Dashboard", views: ["Educator"] }, // example
  { path: "/map", label: "Treasure Map", views: ["Student","Educator"] },
  // ...add your real routes here...
];

// Basic filter: tweak as needed for state/grade/subject constraints
export function getAccessiblePagesForUser(u) {
  let list = PAGES_META.filter(p => !p.views || p.views.includes(u.view));
  // If you gate by role slug (e.g., nc-1st-educator), refine here:
  // if ((u.role||"").includes("educator")) { /* add educator-only pages */ }
  return list;
}
